



































































import { Component, Mixins, VModel } from 'vue-property-decorator'

import ModelSetter from '../../../../Mixins/ModelSetter'
import { SelectOption } from '../../../../logic/types'
import { UseFields } from '../../../Pi'
import CashRegisterEditorMixin from '../CashRegisterEditorMixin'
import { Yookassa, YookassaVatCode } from '../types'

@Component({})
export default class YookassaSetting extends Mixins<UseFields, ModelSetter, CashRegisterEditorMixin>(UseFields, ModelSetter, CashRegisterEditorMixin) {
  @VModel() model!: Yookassa

  get vatCodeOptions(): Array<SelectOption> {
    return [
      { label: this.$t(`yookassa_vat_code_option_${ YookassaVatCode.VatCode1 }`), value: YookassaVatCode.VatCode1 },
      { label: this.$t(`yookassa_vat_code_option_${ YookassaVatCode.VatCode2 }`), value: YookassaVatCode.VatCode2 },
      { label: this.$t(`yookassa_vat_code_option_${ YookassaVatCode.VatCode3 }`), value: YookassaVatCode.VatCode3 },
      { label: this.$t(`yookassa_vat_code_option_${ YookassaVatCode.VatCode4 }`), value: YookassaVatCode.VatCode4 },
      { label: this.$t(`yookassa_vat_code_option_${ YookassaVatCode.VatCode5 }`), value: YookassaVatCode.VatCode5 },
      { label: this.$t(`yookassa_vat_code_option_${ YookassaVatCode.VatCode6 }`), value: YookassaVatCode.VatCode6 },
    ]
  }

  onAddReceiptChange({ checked }: {checked: boolean}) {
    if (!checked) {
      this.model.vat_code = null
    } else {
      this.model.vat_code = YookassaVatCode.VatCode1
    }
  }
}
